import React from "react";
import { Link } from "react-router";
import Check from "@material-ui/icons/Check";
import { formatFullName } from "../../../../lib/utils";

function AttendeesTableRecord(props) {
  const {
    attendee: {
      assignedVenueName,
      campusName,
      id,
      shliachFirstName,
      shliachLastName,
      firstName,
      lastName,
      status,
      statusDisplay,
      attendeeType,
      attendeeTypeDisplay,
      enrollmentID,
    },
    isCheckInEnabled,
    isTravelTrip,
    onRevertAttendeeCheckin,
    readOnlyAccess,
    scheduleId,
    selected = "",
    toggleSelectAttendee,
  } = props;

  const attendeeLink =
    attendeeType === "Student"
      ? `/trips/${scheduleId}/students/${id}`
      : attendeeType === "OtherAttendee"
        ? `/programs/trips/${scheduleId}?tab=other-attendees` // other attendees are edited in event settings
        : `/trips/${scheduleId}/enrollments/${enrollmentID}`;

  const checkedIn = status === "CheckedIn";

  return (
    <div
      className={`attendees-table-columns${
        !isCheckInEnabled ? " compact" : ""
      } trip-students-table-row${readOnlyAccess ? " read-only" : ""}${
        checkedIn ? " disabled" : ""
      }`}
    >
      {!readOnlyAccess && isCheckInEnabled && (
        <div className="flex custom-checkbox-container">
          {checkedIn ? (
            <Check />
          ) : (
            <input
              className="custom-checkbox"
              checked={selected}
              id={`${id}-${attendeeType}`}
              onChange={toggleSelectAttendee}
              type="checkbox"
            />
          )}
          <label
            className="flex-align-center"
            htmlFor={`${id}-${attendeeType}`}
          />
        </div>
      )}

      <p>
        <Link className="link-text-secondary" to={attendeeLink} target="_blank">
          {formatFullName(firstName, lastName)}
        </Link>
      </p>

      <div>
        <p>{campusName}</p>
        <p className="fw-400 accent-text mb-4">
          {formatFullName(shliachFirstName, shliachLastName)}
        </p>
      </div>

      {!isTravelTrip && (
        <>
          <p>{attendeeTypeDisplay}</p>
          <p>{assignedVenueName}</p>
        </>
      )}

      {isCheckInEnabled && (
        <p className="flex flex-align-center">
          {statusDisplay}
          {checkedIn && (
            <i
              className="material-icons link-text ml-8"
              onClick={onRevertAttendeeCheckin}
            >
              undo
            </i>
          )}
        </p>
      )}
    </div>
  );
}
export default React.memo(AttendeesTableRecord);
